import axios, { type AxiosError, type AxiosInstance } from 'axios';

import { env } from '@/shared/lib/env';

import { toApiError } from './errors';

export const apiClient: AxiosInstance = axios.create({
  baseURL: env.VITE_API_BASE_URL,
  withCredentials: true,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});

/**
 * `getAccessToken` y `onUnauthorized` se registran al boot por `registerAuthBridge`
 * para evitar dependencia circular entre `shared/api` y `app/store`.
 */
type GetAccessToken = () => string | null;
type OnUnauthorized = () => void;

const noop: OnUnauthorized = () => undefined;
let getAccessToken: GetAccessToken = () => null;
let onUnauthorized: OnUnauthorized = noop;

export function registerAuthBridge(bridge: {
  getAccessToken: GetAccessToken;
  onUnauthorized: OnUnauthorized;
}): void {
  getAccessToken = bridge.getAccessToken;
  onUnauthorized = bridge.onUnauthorized;
}

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      onUnauthorized();
    }
    return Promise.reject(toApiError(error));
  },
);
